module.exports = __webpack_public_path__ + "img/service.d0e633a3.jpg";